export default "__VITE_ASSET__Chfv74LM__"